module.exports = __webpack_public_path__ + "img/contactPic.d7a5ac34.png";